webpackJsonp([1],{

/***/ "2Jh6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EPyT":
/***/ (function(module, exports) {

/*
 StackBlur - a fast almost Gaussian Blur For Canvas

 Version:     0.5
 Author:        Mario Klingemann
 Contact:     mario@quasimondo.com
 Website:    http://www.quasimondo.com/StackBlurForCanvas
 Twitter:    @quasimondo

 In case you find this class useful - especially in commercial projects -
 I am not totally unhappy for a small donation to my PayPal account
 mario@quasimondo.de

 Or support me on flattr:
 https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript

 Copyright (c) 2010 Mario Klingemann

 Permission is hereby granted, free of charge, to any person
 obtaining a copy of this software and associated documentation
 files (the "Software"), to deal in the Software without
 restriction, including without limitation the rights to use,
 copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the
 Software is furnished to do so, subject to the following
 conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 OTHER DEALINGS IN THE SOFTWARE.
 */

var mul_table = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259];

var shg_table = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];

function processImage(img, canvas, radius, blurAlphaChannel) {
  if (typeof img == 'string') {
    var img = document.getElementById(img);
  } else if (typeof HTMLImageElement !== 'undefined' && !img instanceof HTMLImageElement) {
    return;
  }
  var w = img.naturalWidth;
  var h = img.naturalHeight;

  if (typeof canvas == 'string') {
    var canvas = document.getElementById(canvas);
  } else if (typeof HTMLCanvasElement !== 'undefined' && !canvas instanceof HTMLCanvasElement) {
    return;
  }

  // canvas.style.width  = w + 'px';
  // canvas.style.height = h + 'px';
  // canvas.width = w;
  // canvas.height = h;

  var context = canvas.getContext('2d');
  context.clearRect(0, 0, w, h);
  context.drawImage(img, 0, 0);

  if (isNaN(radius) || radius < 1) return;

  if (blurAlphaChannel) processCanvasRGBA(canvas, 0, 0, w, h, radius);else processCanvasRGB(canvas, 0, 0, w, h, radius);
}

function getImageDataFromCanvas(canvas, top_x, top_y, width, height) {
  if (typeof canvas == 'string') var canvas = document.getElementById(canvas);else if (typeof HTMLCanvasElement !== 'undefined' && !canvas instanceof HTMLCanvasElement) return;

  var context = canvas.getContext('2d');
  var imageData;

  try {
    try {
      imageData = context.getImageData(top_x, top_y, width, height);
    } catch (e) {
      throw new Error("unable to access local image data: " + e);
      return;
    }
  } catch (e) {
    throw new Error("unable to access image data: " + e);
  }

  return imageData;
}

function processCanvasRGBA(canvas, top_x, top_y, width, height, radius) {
  if (isNaN(radius) || radius < 1) return;
  radius |= 0;

  var imageData = getImageDataFromCanvas(canvas, top_x, top_y, width, height);

  imageData = processImageDataRGBA(imageData, top_x, top_y, width, height, radius);

  canvas.getContext('2d').putImageData(imageData, top_x, top_y);
}

function processImageDataRGBA(imageData, top_x, top_y, width, height, radius) {
  var pixels = imageData.data;
  var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;

  var div = radius + radius + 1;
  var w4 = width << 2;
  var widthMinus1 = width - 1;
  var heightMinus1 = height - 1;
  var radiusPlus1 = radius + 1;
  var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;

  var stackStart = new BlurStack();
  var stack = stackStart;
  for (i = 1; i < div; i++) {
    stack = stack.next = new BlurStack();
    if (i == radiusPlus1) var stackEnd = stack;
  }
  stack.next = stackStart;
  var stackIn = null;
  var stackOut = null;

  yw = yi = 0;

  var mul_sum = mul_table[radius];
  var shg_sum = shg_table[radius];

  for (y = 0; y < height; y++) {
    r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;

    r_out_sum = radiusPlus1 * (pr = pixels[yi]);
    g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
    b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
    a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);

    r_sum += sumFactor * pr;
    g_sum += sumFactor * pg;
    b_sum += sumFactor * pb;
    a_sum += sumFactor * pa;

    stack = stackStart;

    for (i = 0; i < radiusPlus1; i++) {
      stack.r = pr;
      stack.g = pg;
      stack.b = pb;
      stack.a = pa;
      stack = stack.next;
    }

    for (i = 1; i < radiusPlus1; i++) {
      p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
      r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
      g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
      b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
      a_sum += (stack.a = pa = pixels[p + 3]) * rbs;

      r_in_sum += pr;
      g_in_sum += pg;
      b_in_sum += pb;
      a_in_sum += pa;

      stack = stack.next;
    }

    stackIn = stackStart;
    stackOut = stackEnd;
    for (x = 0; x < width; x++) {
      pixels[yi + 3] = pa = a_sum * mul_sum >> shg_sum;
      if (pa != 0) {
        pa = 255 / pa;
        pixels[yi] = (r_sum * mul_sum >> shg_sum) * pa;
        pixels[yi + 1] = (g_sum * mul_sum >> shg_sum) * pa;
        pixels[yi + 2] = (b_sum * mul_sum >> shg_sum) * pa;
      } else {
        pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
      }

      r_sum -= r_out_sum;
      g_sum -= g_out_sum;
      b_sum -= b_out_sum;
      a_sum -= a_out_sum;

      r_out_sum -= stackIn.r;
      g_out_sum -= stackIn.g;
      b_out_sum -= stackIn.b;
      a_out_sum -= stackIn.a;

      p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;

      r_in_sum += stackIn.r = pixels[p];
      g_in_sum += stackIn.g = pixels[p + 1];
      b_in_sum += stackIn.b = pixels[p + 2];
      a_in_sum += stackIn.a = pixels[p + 3];

      r_sum += r_in_sum;
      g_sum += g_in_sum;
      b_sum += b_in_sum;
      a_sum += a_in_sum;

      stackIn = stackIn.next;

      r_out_sum += pr = stackOut.r;
      g_out_sum += pg = stackOut.g;
      b_out_sum += pb = stackOut.b;
      a_out_sum += pa = stackOut.a;

      r_in_sum -= pr;
      g_in_sum -= pg;
      b_in_sum -= pb;
      a_in_sum -= pa;

      stackOut = stackOut.next;

      yi += 4;
    }
    yw += width;
  }

  for (x = 0; x < width; x++) {
    g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;

    yi = x << 2;
    r_out_sum = radiusPlus1 * (pr = pixels[yi]);
    g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
    b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
    a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);

    r_sum += sumFactor * pr;
    g_sum += sumFactor * pg;
    b_sum += sumFactor * pb;
    a_sum += sumFactor * pa;

    stack = stackStart;

    for (i = 0; i < radiusPlus1; i++) {
      stack.r = pr;
      stack.g = pg;
      stack.b = pb;
      stack.a = pa;
      stack = stack.next;
    }

    yp = width;

    for (i = 1; i <= radius; i++) {
      yi = yp + x << 2;

      r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
      g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
      b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
      a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;

      r_in_sum += pr;
      g_in_sum += pg;
      b_in_sum += pb;
      a_in_sum += pa;

      stack = stack.next;

      if (i < heightMinus1) {
        yp += width;
      }
    }

    yi = x;
    stackIn = stackStart;
    stackOut = stackEnd;
    for (y = 0; y < height; y++) {
      p = yi << 2;
      pixels[p + 3] = pa = a_sum * mul_sum >> shg_sum;
      if (pa > 0) {
        pa = 255 / pa;
        pixels[p] = (r_sum * mul_sum >> shg_sum) * pa;
        pixels[p + 1] = (g_sum * mul_sum >> shg_sum) * pa;
        pixels[p + 2] = (b_sum * mul_sum >> shg_sum) * pa;
      } else {
        pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
      }

      r_sum -= r_out_sum;
      g_sum -= g_out_sum;
      b_sum -= b_out_sum;
      a_sum -= a_out_sum;

      r_out_sum -= stackIn.r;
      g_out_sum -= stackIn.g;
      b_out_sum -= stackIn.b;
      a_out_sum -= stackIn.a;

      p = x + ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;

      r_sum += r_in_sum += stackIn.r = pixels[p];
      g_sum += g_in_sum += stackIn.g = pixels[p + 1];
      b_sum += b_in_sum += stackIn.b = pixels[p + 2];
      a_sum += a_in_sum += stackIn.a = pixels[p + 3];

      stackIn = stackIn.next;

      r_out_sum += pr = stackOut.r;
      g_out_sum += pg = stackOut.g;
      b_out_sum += pb = stackOut.b;
      a_out_sum += pa = stackOut.a;

      r_in_sum -= pr;
      g_in_sum -= pg;
      b_in_sum -= pb;
      a_in_sum -= pa;

      stackOut = stackOut.next;

      yi += width;
    }
  }
  return imageData;
}

function processCanvasRGB(canvas, top_x, top_y, width, height, radius) {
  if (isNaN(radius) || radius < 1) return;
  radius |= 0;

  var imageData = getImageDataFromCanvas(canvas, top_x, top_y, width, height);
  imageData = processImageDataRGB(imageData, top_x, top_y, width, height, radius);

  canvas.getContext('2d').putImageData(imageData, top_x, top_y);
}

function processImageDataRGB(imageData, top_x, top_y, width, height, radius) {
  var pixels = imageData.data;
  var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum, r_out_sum, g_out_sum, b_out_sum, r_in_sum, g_in_sum, b_in_sum, pr, pg, pb, rbs;

  var div = radius + radius + 1;
  var w4 = width << 2;
  var widthMinus1 = width - 1;
  var heightMinus1 = height - 1;
  var radiusPlus1 = radius + 1;
  var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;

  var stackStart = new BlurStack();
  var stack = stackStart;
  for (i = 1; i < div; i++) {
    stack = stack.next = new BlurStack();
    if (i == radiusPlus1) var stackEnd = stack;
  }
  stack.next = stackStart;
  var stackIn = null;
  var stackOut = null;

  yw = yi = 0;

  var mul_sum = mul_table[radius];
  var shg_sum = shg_table[radius];

  for (y = 0; y < height; y++) {
    r_in_sum = g_in_sum = b_in_sum = r_sum = g_sum = b_sum = 0;

    r_out_sum = radiusPlus1 * (pr = pixels[yi]);
    g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
    b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);

    r_sum += sumFactor * pr;
    g_sum += sumFactor * pg;
    b_sum += sumFactor * pb;

    stack = stackStart;

    for (i = 0; i < radiusPlus1; i++) {
      stack.r = pr;
      stack.g = pg;
      stack.b = pb;
      stack = stack.next;
    }

    for (i = 1; i < radiusPlus1; i++) {
      p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
      r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
      g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
      b_sum += (stack.b = pb = pixels[p + 2]) * rbs;

      r_in_sum += pr;
      g_in_sum += pg;
      b_in_sum += pb;

      stack = stack.next;
    }

    stackIn = stackStart;
    stackOut = stackEnd;
    for (x = 0; x < width; x++) {
      pixels[yi] = r_sum * mul_sum >> shg_sum;
      pixels[yi + 1] = g_sum * mul_sum >> shg_sum;
      pixels[yi + 2] = b_sum * mul_sum >> shg_sum;

      r_sum -= r_out_sum;
      g_sum -= g_out_sum;
      b_sum -= b_out_sum;

      r_out_sum -= stackIn.r;
      g_out_sum -= stackIn.g;
      b_out_sum -= stackIn.b;

      p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;

      r_in_sum += stackIn.r = pixels[p];
      g_in_sum += stackIn.g = pixels[p + 1];
      b_in_sum += stackIn.b = pixels[p + 2];

      r_sum += r_in_sum;
      g_sum += g_in_sum;
      b_sum += b_in_sum;

      stackIn = stackIn.next;

      r_out_sum += pr = stackOut.r;
      g_out_sum += pg = stackOut.g;
      b_out_sum += pb = stackOut.b;

      r_in_sum -= pr;
      g_in_sum -= pg;
      b_in_sum -= pb;

      stackOut = stackOut.next;

      yi += 4;
    }
    yw += width;
  }

  for (x = 0; x < width; x++) {
    g_in_sum = b_in_sum = r_in_sum = g_sum = b_sum = r_sum = 0;

    yi = x << 2;
    r_out_sum = radiusPlus1 * (pr = pixels[yi]);
    g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
    b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);

    r_sum += sumFactor * pr;
    g_sum += sumFactor * pg;
    b_sum += sumFactor * pb;

    stack = stackStart;

    for (i = 0; i < radiusPlus1; i++) {
      stack.r = pr;
      stack.g = pg;
      stack.b = pb;
      stack = stack.next;
    }

    yp = width;

    for (i = 1; i <= radius; i++) {
      yi = yp + x << 2;

      r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
      g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
      b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;

      r_in_sum += pr;
      g_in_sum += pg;
      b_in_sum += pb;

      stack = stack.next;

      if (i < heightMinus1) {
        yp += width;
      }
    }

    yi = x;
    stackIn = stackStart;
    stackOut = stackEnd;
    for (y = 0; y < height; y++) {
      p = yi << 2;
      pixels[p] = r_sum * mul_sum >> shg_sum;
      pixels[p + 1] = g_sum * mul_sum >> shg_sum;
      pixels[p + 2] = b_sum * mul_sum >> shg_sum;

      r_sum -= r_out_sum;
      g_sum -= g_out_sum;
      b_sum -= b_out_sum;

      r_out_sum -= stackIn.r;
      g_out_sum -= stackIn.g;
      b_out_sum -= stackIn.b;

      p = x + ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;

      r_sum += r_in_sum += stackIn.r = pixels[p];
      g_sum += g_in_sum += stackIn.g = pixels[p + 1];
      b_sum += b_in_sum += stackIn.b = pixels[p + 2];

      stackIn = stackIn.next;

      r_out_sum += pr = stackOut.r;
      g_out_sum += pg = stackOut.g;
      b_out_sum += pb = stackOut.b;

      r_in_sum -= pr;
      g_in_sum -= pg;
      b_in_sum -= pb;

      stackOut = stackOut.next;

      yi += width;
    }
  }

  return imageData;
}

function BlurStack() {
  this.r = 0;
  this.g = 0;
  this.b = 0;
  this.a = 0;
  this.next = null;
}

module.exports = {
  image: processImage,
  canvasRGBA: processCanvasRGBA,
  canvasRGB: processCanvasRGB,
  imageDataRGBA: processImageDataRGBA,
  imageDataRGB: processImageDataRGB
};

/***/ }),

/***/ "K38B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/css/customer.less
var customer = __webpack_require__("ioxL");
var customer_default = /*#__PURE__*/__webpack_require__.n(customer);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/components/customer.js
/**
 * Created by lenovo on 2017/11/21.
 */

var prefixCls = 'age';
// EXTERNAL MODULE: ./src/components/ripple/ripple.less
var ripple = __webpack_require__("k7QP");
var ripple_default = /*#__PURE__*/__webpack_require__.n(ripple);

// CONCATENATED MODULE: ./src/components/utils/index.js
/**
 * Created by wython on 2017/11/21.
 */

/**
 * 获取元素的背景颜色，先获取行内元素，在获取计算样式
 * @param ele {DomElement|String}
 * @return {String|Boolean}
 */

function getBg(ele) {
  if (typeof ele === 'string') ele = document.getElementById(ele);

  if (!ele) throw new Error('参数Ele不是合法的DOM元素');

  if (ele.style && ele.style.backgroundColor) return ele.style.backgroundColor;
  var eleStyle = window.getComputedStyle ? window.getComputedStyle(ele) : ele.currentStyle;
  if (!eleStyle) {
    return false;
  } else {
    return eleStyle.backgroundColor;
  }
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ripple/ripple.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var ripplePrefixCls = prefixCls + '-ripple';

/* harmony default export */ var ripple_ripple = ({
  name: 'ripple',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      width: 100,
      height: 100,
      bgColor: '#2789e9',
      wrapperBg: ''
    };
  },

  computed: {
    //波纹动态样式
    circleStyle: function circleStyle() {
      return {
        backgroundColor: this.bgColor,
        width: this.width + 'px',
        height: this.height + 'px'
      };
    },


    //波纹外层类
    rippleCls: function rippleCls() {
      return [defineProperty_default()({}, ripplePrefixCls + '-animated', this.loading), ripplePrefixCls + '-wrapper'];
    }
  },
  mounted: function mounted() {
    var wrapperEle = this.$refs['ripple'];

    //获得wrapper元素背景颜色
    this.bgColor = getBg(wrapperEle);
    //this.wrapperBg = 'transparent';

    wrapperEle.setAttribute('style', 'background-color:' + this.wrapperBg + ';' + (wrapperEle.getAttribute('style') || ''));
    //获得wrapper元素的width，height
    this.width = wrapperEle.clientWidth;
    this.height = wrapperEle.clientHeight;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-979f9462","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ripple/ripple.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ripple",class:_vm.rippleCls},[_c('div',{staticClass:"slot"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"c-1",style:(_vm.circleStyle)}),_vm._v(" "),_c('div',{staticClass:"c-2",style:(_vm.circleStyle)}),_vm._v(" "),_c('div',{staticClass:"c-3",style:(_vm.circleStyle)}),_vm._v(" "),_c('div',{staticClass:"c-4",style:(_vm.circleStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_ripple_ripple = (esExports);
// CONCATENATED MODULE: ./src/components/ripple/ripple.vue
function injectStyle (ssrContext) {
  __webpack_require__("2Jh6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ripple_ripple,
  components_ripple_ripple,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_ripple_ripple = (Component.exports);

// CONCATENATED MODULE: ./src/components/ripple/index.js
/**
 * Created by wython on 2017/11/21.
 */



/* harmony default export */ var components_ripple = (src_components_ripple_ripple);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/search/search.vue
//
//
//
//
//
//

/* harmony default export */ var search = ({
  name: 'search',
  props: {
    placeholder: String
  },
  data: function data() {
    return {
      clickSearch: false,
      value: ''
    };
  },

  methods: {
    openSearch: function openSearch(e) {
      if (this.value) {
        this.$emit('search', this.value);
      } else {
        this.clickSearch = !this.clickSearch;
      }
    },
    inputBlur: function inputBlur(e) {
      this.clickSearch = false;
    }
  },
  computed: {
    open: function open() {
      return this.value || this.clickSearch;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43249176","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/search.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['age-search', { 'age-search-open': _vm.open }]},[_c('span',{staticClass:"icon search-icon",on:{"click":_vm.openSearch}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"placeholder":_vm.placeholder},domProps:{"value":(_vm.value)},on:{"blur":_vm.inputBlur,"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])}
var search_staticRenderFns = []
var search_esExports = { render: search_render, staticRenderFns: search_staticRenderFns }
/* harmony default export */ var search_search = (search_esExports);
// CONCATENATED MODULE: ./src/components/search/search.vue
function search_injectStyle (ssrContext) {
  __webpack_require__("je8i")
}
var search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = search_injectStyle
/* scopeId */
var search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null
var search_Component = search_normalizeComponent(
  search,
  search_search,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)

/* harmony default export */ var components_search_search = (search_Component.exports);

// CONCATENATED MODULE: ./src/components/search/index.js
/**
 * Created by wython on 2017/11/23.
 */



/* harmony default export */ var components_search = (components_search_search);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var header = ({
    name: 'global-header',
    components: {
        Ripple: components_ripple,
        Search: components_search
    },
    data: function data() {
        return {
            loading: false,
            showMiniMenu: true
        };
    },
    beforeMount: function beforeMount() {
        var _this = this;

        //测试loading
        setInterval(function () {
            _this.loading = !_this.loading;
        }, 5000);
    },

    methods: {
        openMiniMenu: function openMiniMenu(e) {
            this.showMiniMenu = !this.showMiniMenu;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c356dbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/header.vue
var header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"global-header"}},[_c('nav',{staticClass:"header-nav"},[_c('div',{staticClass:"header-user"},[_c('Ripple',{staticClass:"header-ripple",attrs:{"loading":_vm.loading}},[_c('div',{staticClass:"ripple-content"},[_vm._v("E")])]),_vm._v(" "),_c('h3',{staticClass:"icon"},[_vm._v("wython")])],1),_vm._v(" "),_c('div',{staticClass:"nav-menu"},[_c('Search',{staticClass:"blog-search",attrs:{"placeholder":"search something...."}}),_vm._v(" "),_c('span',{staticClass:"icon mini-search"}),_vm._v(" "),_c('span',{class:['icon', 'mini-button', { 'close': _vm.showMiniMenu }],on:{"click":_vm.openMiniMenu}}),_vm._v(" "),_c('ul',{staticClass:"big-menu"},[_c('li',[_c('router-link',{staticClass:"icon",attrs:{"to":"/","exact":""}},[_vm._v("HOME")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"icon",attrs:{"to":"/tags"}},[_vm._v("TAGS")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"icon",attrs:{"to":"/about"}},[_vm._v("ABOUT")])],1)]),_vm._v(" "),_c('ul',{class:['mini-menu', { 'close': _vm.showMiniMenu }]},[_c('li',[_c('router-link',{staticClass:"icon",attrs:{"to":"/","exact":""}},[_vm._v("HOME")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"icon",attrs:{"to":"/tags"}},[_vm._v("TAGS")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"icon",attrs:{"to":"/about"}},[_vm._v("ABOUT")])],1)])],1)])])}
var header_staticRenderFns = []
var header_esExports = { render: header_render, staticRenderFns: header_staticRenderFns }
/* harmony default export */ var layouts_header = (header_esExports);
// CONCATENATED MODULE: ./src/layouts/header.vue
function header_injectStyle (ssrContext) {
  __webpack_require__("U2pc")
}
var header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var header___vue_template_functional__ = false
/* styles */
var header___vue_styles__ = header_injectStyle
/* scopeId */
var header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var header___vue_module_identifier__ = null
var header_Component = header_normalizeComponent(
  header,
  layouts_header,
  header___vue_template_functional__,
  header___vue_styles__,
  header___vue_scopeId__,
  header___vue_module_identifier__
)

/* harmony default export */ var src_layouts_header = (header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return {
      show: true
    };
  },
  beforeMount: function beforeMount() {
    var dispatch = this.$store.dispatch;


    dispatch('getLabels');
  },

  components: {
    BlogHeader: src_layouts_header
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4c7d85a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"min-height":"100%"},attrs:{"id":"scroll"}},[_c('BlogHeader'),_vm._v(" "),_c('div',{staticClass:"app-content"},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1)],1)],1),_vm._v(" "),_vm._m(0)])}
var App_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticStyle:{"width":"100%","display":"flex","align-items":"center","justify-content":"center"}},[_vm._v("\n    ©2017 - 2017 | "),_c('span',{staticStyle:{"color":"#595959","font-size":"12px"}},[_vm._v("纯手工，不添加任何防腐剂")])])}]
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("WqB3")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Tag/tag.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var tag = ({
  name: 'tag',
  props: {
    src: String,
    color: String
  },
  computed: {
    tagStyle: function tagStyle() {
      var color = {
        cursor: this.src ? 'pointer' : 'default'
      };
      if (this.color) {
        color['background-color'] = '#' + this.color;
        color['border-color'] = '#' + this.color;
      }

      return color;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0a40d66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tag/tag.vue
var tag_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('router-link',{staticClass:"age-tag icon",style:(_vm.tagStyle),attrs:{"to":_vm.src}},[_vm._t("default")],2):_c('a',{staticClass:"age-tag icon",style:(_vm.tagStyle)},[_vm._t("default")],2)}
var tag_staticRenderFns = []
var tag_esExports = { render: tag_render, staticRenderFns: tag_staticRenderFns }
/* harmony default export */ var Tag_tag = (tag_esExports);
// CONCATENATED MODULE: ./src/components/Tag/tag.vue
function tag_injectStyle (ssrContext) {
  __webpack_require__("K38B")
}
var tag_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tag___vue_template_functional__ = false
/* styles */
var tag___vue_styles__ = tag_injectStyle
/* scopeId */
var tag___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tag___vue_module_identifier__ = null
var tag_Component = tag_normalizeComponent(
  tag,
  Tag_tag,
  tag___vue_template_functional__,
  tag___vue_styles__,
  tag___vue_scopeId__,
  tag___vue_module_identifier__
)

/* harmony default export */ var components_Tag_tag = (tag_Component.exports);

// CONCATENATED MODULE: ./src/components/Tag/index.js
/**
 * Created by wython on 2017/11/23.
 */


/* harmony default export */ var Tag = (components_Tag_tag);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/marked/lib/marked.js
var marked = __webpack_require__("EFqf");
var marked_default = /*#__PURE__*/__webpack_require__.n(marked);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/ArticleList/ArticleItem/articleItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var articleItem = ({
  components: {
    Tag: Tag
  },
  props: {
    blog: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  data: function data() {
    return {
      moment: moment_default.a,
      mark: marked_default.a
    };
  },
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59c2d2b1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/ArticleList/ArticleItem/articleItem.vue
var articleItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"article-item"},[_c('h2',[_c('router-link',{attrs:{"to":("/article/" + (_vm.blog.number))}},[_vm._v("\n      "+_vm._s(_vm.blog.title)+"\n    ")])],1),_vm._v(" "),_c('p',{staticClass:"article-mess"},[_c('span',{staticClass:"date-line"},[_vm._v(_vm._s(_vm.moment.duration(Date.now() - Date.parse(new Date(_vm.blog.created_at))).humanize(true))+" | "),_c('span',{staticClass:"icon eye"}),_vm._v(" 评论数 "+_vm._s(_vm.blog.comments))])]),_vm._v(" "),_c('div',{staticClass:"article-marked-box overflow",attrs:{"id":"marked-view"},domProps:{"innerHTML":_vm._s(_vm.mark(_vm.blog.body))}}),_vm._v(" "),_c('p',[_vm._v("\n    标签："),_vm._l((_vm.blog.labels),function(tag){return _c('Tag',{key:tag.id},[_vm._v(_vm._s(tag.name))])})],2),_vm._v(" "),_c('span',{staticClass:"article-more icon"},[_c('router-link',{attrs:{"to":("/article/" + (_vm.blog.number))}},[_vm._v("\n      MORE "),_c('span',{staticClass:"icon"})])],1),_vm._v(" "),_c('span',{staticClass:"bottom-line clear"})])}
var articleItem_staticRenderFns = []
var articleItem_esExports = { render: articleItem_render, staticRenderFns: articleItem_staticRenderFns }
/* harmony default export */ var ArticleItem_articleItem = (articleItem_esExports);
// CONCATENATED MODULE: ./src/layouts/ArticleList/ArticleItem/articleItem.vue
function articleItem_injectStyle (ssrContext) {
  __webpack_require__("il8T")
}
var articleItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var articleItem___vue_template_functional__ = false
/* styles */
var articleItem___vue_styles__ = articleItem_injectStyle
/* scopeId */
var articleItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var articleItem___vue_module_identifier__ = null
var articleItem_Component = articleItem_normalizeComponent(
  articleItem,
  ArticleItem_articleItem,
  articleItem___vue_template_functional__,
  articleItem___vue_styles__,
  articleItem___vue_scopeId__,
  articleItem___vue_module_identifier__
)

/* harmony default export */ var ArticleList_ArticleItem_articleItem = (articleItem_Component.exports);

// CONCATENATED MODULE: ./src/layouts/ArticleList/ArticleItem/index.js
/**
 * Created by wython on 2017/11/23.
 */



/* harmony default export */ var ArticleItem = (ArticleList_ArticleItem_articleItem);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// CONCATENATED MODULE: ./src/utils/position.js
/**
 * Created by wython on 2017/11/22.
 */

/**
 * check element
 * 判断ele
 * @param ele
 * @return {*}
 */
function getEle(ele) {
  if (typeof ele === 'string') ele = document.getElementById(ele);
  if (!ele) throw new Error('参数Ele不是合法的DOM元素');
  return ele;
}

/**
 * get element style by js
 * 通过js获取元素样式
 *
 * @param ele
 * @param key
 * @return {*}
 */
function getStyle(ele, key) {
  ele = getEle(ele);
  if (ele.style && ele.style[key]) return ele.style[key]; //形内样式
  var eleStyle = window.getComputedStyle ? window.getComputedStyle(ele) : ele.currentStyle;
  return eleStyle ? eleStyle[key] : false;
}

/**
 *
 * get Element background color, first, get the style inline,
 * and then, get thought computed style
 * 获取元素的背景颜色，先获取行内元素，在获取计算样式
 *
 * @param ele {Element|String}
 * @return {String|Boolean}
 */
function position_getBg(ele) {
  return getStyle(ele, 'backgroundColor');
}

/**
 *
 * computed the element view port
 * 获取页面可视区域大小
 * @return {{width: number, height: number}}
 */
function getViewPort() {
  if (document.compatMode == "BackCompat") {
    //ie6文档模式下
    return {
      width: document.body.clientWidth,
      height: document.body.clientHeight
    };
  } else {
    return {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight
    };
  }
}

/**
 *
 * @param ele
 * @param position{String} 'top' | 'left'
 */
function getDistance(ele, position) {
  ele = getEle(ele);
  position = position.replace(position.charAt(0), position.charAt(0).toUpperCase());

  var distanceKey = 'offset' + position;
  var current = ele.offsetParent;

  var distance = getEle(ele)[distanceKey];
  while (current) {
    distance += current[distanceKey];
    current = current.offsetParent;
  }

  return distance;
}

/**
 * 获取绝对left
 * @param ele
 * @return {*}
 */
function getAbLeft(ele) {
  return getDistance(ele, 'Left');
}

/**
 * 获取绝对height
 * @param ele
 * @return {*}
 */
function getAbTop(ele) {
  return getDistance(ele, 'Top');
}

/**
 *
 * 获取元素绝对值坐标
 *
 * @param ele
 * @return {{top: *, left: *}}
 */
function absolutePosition(ele) {
  var quick = ele.getBoundingClientRect();

  return {
    top: quick ? quick.top : getAbTop(ele),
    left: quick ? quick.left : getAbLeft(ele)
  };
}

function getReTop(ele) {
  if (document.compatMode !== 'BackCompat') {
    return getAbTop(ele) - document.body.scrollTop;
  } else {
    return getAbTop(ele) - document.documentElement.scrollTop;
  }
}

function getReLeft(ele) {
  if (document.compatMode !== 'BackCompat') {
    return getAbLeft(ele) - document.body.scrollLeft;
  } else {
    return getAbLeft(ele) - document.documentElement.scrollLeft;
  }
}

/**
 * 获取元素可视化区域位置
 *
 * @param ele
 * @return {{left: *, top: *}}
 */
function getViewPosition(ele) {
  return {
    left: getReLeft(ele),
    top: getReTop(ele)
  };
}
// EXTERNAL MODULE: ./src/utils/lazyImage/style.less
var style = __webpack_require__("jikQ");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./src/utils/lazyImage/lazyImage.js


/**
 * Created by wython on 2017/12/1.
 */



var StackBlur = __webpack_require__("EPyT");

/**
 * 节流函数
 * @param fn
 * @param delay
 */
function throttle(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;

  var timeoutId = null;
  return function (e) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(function () {
      fn && fn(e);
    }, delay);
  };
}
/**
 * opt = { glass, miniSrc = (src) => { return '' },   }
 */

var lazyImage_LazyImage = function LazyImage(target, opt) {
  var _this = this;

  classCallCheck_default()(this, LazyImage);

  this.start = function () {
    _this.opt.miniSrc && _this.opt.glass && _this.insertCanvas();

    window.addEventListener('scroll', throttle(_this.bindScroll.bind(_this)));
  };

  this.bindScroll = function (e) {
    _this.loadImages(e);
  };

  this.loadImages = function (e) {
    _this.images.forEach(function (img) {
      var imgRegPos = getReTop(img);
      var doc = document.documentElement || document.body;
      var docTop = doc.scrollTop;
      var docClientHeight = doc.clientHeight;

      // 判断是否进入视野, 图片进入当前视图的1/3之后开始懒加载
      if (docTop + docClientHeight * 2 / 3 - imgRegPos > 0) {
        img.src = img.dataset.src;

        img.onload = function () {
          img.canvas.classList.add('stack-blur-canvas-hidden');
        };
      }
    });
  };

  this.clear = function () {
    window.removeEventListener('scroll', _this.bindScroll);
  };

  this.getImageWidth = function (img, parentNode) {
    if (img.style.width) {
      if (img.style.width.indexOf('%') + 1) {
        // 百分比
        return (parentNode.style.width || parentNode.clientWidth) * parseInt(img.style.width) / 100;
      } else {
        return img.style.width;
      }
    } else {
      return img.clientWidth || img.dataset.width || 1000;
    }
  };

  this.insertCanvas = function () {
    _this.images = _this.images.map(function (img) {
      // img.classList.add('original-bg');
      // 预加载缩略图
      var miniImg = new Image();
      var parentNode = img.parentNode;
      var canvas = document.createElement('canvas');

      var newImage = img.cloneNode(true); // true 完全克隆
      var newDiv = document.createElement('div');
      newDiv.classList.add('lazy-image-wrapper');
      newDiv.appendChild(newImage);
      newDiv.appendChild(canvas);

      var canvasWidth = _this.getImageWidth(newImage, parentNode);

      var canvasHeight = newImage.clientHeight || newImage.dataset.height;

      miniImg.onload = function () {
        if (!canvasHeight) {
          canvasHeight = canvasWidth * miniImg.height / miniImg.width;
          // init original image width and height if not
          // 初始化原始图片高宽, 如果没有的话。
          newImage.style.width = canvasWidth + 'px';
          newImage.style.height = canvasHeight + 'px';
          newImage.width = canvasWidth;
          newImage.height = canvasHeight;
        }
        StackBlur.image(miniImg, canvas, 50);

        // 定义canvas位置与img重合
        canvas.style.width = canvasWidth + 'px';
        canvas.style.height = canvasHeight + 'px';

        // parentNode.insertBefore(canvas, img);
        // canvas.style.position = 'absolute';
        // canvas.style.top  = img.offsetTop + 'px';
        // canvas.style.left = img.offsetLeft + 'px';
        newImage.canvas = canvas;

        canvas.classList.add('stack-blur-canvas-transition');
        parentNode.replaceChild(newDiv, img);
      };
      miniImg.src = _this.opt.miniSrc(newImage.dataset.src || newImage.src);
      return newImage;
    });
  };

  this.opt = assign_default()({
    glass: true
  }, opt);
  this.target = getEle(target);
  this.images = Array.prototype.slice.call(this.target.getElementsByTagName('img'));
}

// 判断是否,加载原图
;

/* harmony default export */ var lazyImage = (lazyImage_LazyImage);
// CONCATENATED MODULE: ./src/utils/lazyImage/index.js
/**
 * Created by lenovo on 2017/12/6.
 */



/* harmony default export */ var utils_lazyImage = (lazyImage);
// CONCATENATED MODULE: ./src/utils/drag.js

/**
 * 拖拽封装
 * Created by WYTHON on 2017/11/20.
 */

var DRAG_TYPE_LIST = ['x', 'y', 'all'];



/**
 * 移动的元素选中时触发
 * @param e
 */
function onMouseDown(e) {
  e.preventDefault();
  this.flat = true;
  this.currentX = e.clientX; //鼠标位置
  this.currentY = e.clientY;

  this.downFn.forEach(function (fn) {
    fn && fn(e);
  });
}

/**
 * 移动元素完毕之后触发
 * @param e
 */
function onMouseUp(e) {
  if (!this.flat) return;
  this.flat = false;
  this.currentLeft = this.getLeft();
  this.currentTop = this.getTop();

  this.upFn.forEach(function (fn) {
    fn && fn(e);
  });
}

/**
 * 鼠标移动时触发
 * @param e
 * @return {boolean}
 */
function onMouseMoving(e) {

  if (!this.flat) return false;
  var nowX = e.clientX;
  var nowY = e.clientY;
  var disX = nowX - this.currentX;
  var disY = nowY - this.currentY;

  //window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();
  switch (this.dragType) {
    case 'x':
      //保持y轴不变
      this.setPosition(this.currentLeft + disX, parseInt(this.currentTop));
      break;
    case 'y':
      //保持x轴不变
      this.setPosition(parseInt(this.currentLeft), parseInt(this.currentTop) + disY);
      break;
    default:
      this.setPosition(parseInt(this.currentLeft) + disX, parseInt(this.currentTop) + disY);
      break;
  }

  this.movingFn.forEach(function (fn) {
    fn(e);
  });
}

/**
 * opt = {
 *   targetType: 'all',  //x: 只沿着拖拽，y：只沿着y运动。'all'：正常拖动
 *   fixed: false,       //是否固定在页面
 *   top: null,          //初始位置
 *   left: null,
 *   container: ele|string
 * }
 *
 *
 * @param target
 * @param opt
 * @return {this}
 * @constructor
 */
function Drag(target, opt) {
  opt = assign_default()({
    dragType: 'all'
  }, opt);
  target = getEle(target);
  if (!(DRAG_TYPE_LIST.indexOf(opt.dragType) > -1)) throw new Error("DragType option must be one of 'x', 'y' or 'all'");
  if (getStyle(target, 'position') === 'fixed') opt.fixed = true;

  opt.container && (this.container = this.addContainer(opt.container));
  this.dragType = opt.dragType;
  this.target = typeof target === 'string' ? document.getElementById(target) : target;
  this.flat = false;

  this.target.style.cursor = 'move';
  this.opt = opt;

  this.downFn = []; //移动前挂载函数
  this.upFn = []; //移动后挂载函数
  this.movingFn = []; //移动时挂载函数

  return this;
};

Drag.prototype.addContainer = function (ele) {
  this.container = getEle(ele);
  return this;
};

Drag.prototype.initPosition = function () {
  if (this.opt.fixed) {
    //是否固定在页面
    this.container.style.position = 'fixed';
    this.currentTop = this.opt.top || this.getEleTop();
    this.currentLeft = this.opt.left || this.getEleLeft();
  } else {
    //不固定，需要计算父级定位元素
    this.container.style.position = 'absolute';
    this.currentTop = this.container.offsetTop;
    this.currentLeft = this.container.offsetLeft;
  }
  this.setPosition(this.currentLeft, this.currentTop);
};

Drag.prototype.on = function (eventType, cb) {
  //event type: down, move, up

  //扩展事件写法
  var mouseupList = ['onmouseup', 'mouseup', 'onMouseUp', 'mouseUp', 'moved'];
  var mousedownList = ['onmousedown', 'mousedown', 'onMouseDown', 'mouseDown', 'beforeMove'];
  var mousemoveList = ['onmousemove', 'mousemove', 'onMouseMove', 'mouseMove', 'moving'];

  if (mouseupList.indexOf(eventType) > -1) {
    this.upFn.push(cb);
    return this;
  }
  if (mousedownList.indexOf(eventType) > -1) {
    this.downFn.push(cb);
    return this;
  }
  if (mousemoveList.indexOf(eventType) > -1) {
    this.movingFn.push(cb);
    return this;
  }
  return this;
};

Drag.prototype.getTop = function () {
  return this.opt.fixed ? this.getEleTop() : this.container.offsetTop;
};

Drag.prototype.getLeft = function () {
  return this.opt.fixed ? this.getEleLeft() : this.container.offsetLeft;
};

Drag.prototype.start = function () {
  if (!this.container) this.container = this.target;

  this.initPosition();

  this.target.addEventListener('mousedown', onMouseDown.bind(this));
  document.body.addEventListener('mousemove', onMouseMoving.bind(this));
  document.body.addEventListener('mouseup', onMouseUp.bind(this));

  return this;
};

Drag.prototype.setPosition = function (x, y) {
  this.container.style.top = y + 'px';
  this.container.style.left = x + 'px';
  return this;
};

Drag.prototype.getEleTop = function () {
  return getReTop(this.container);
};

Drag.prototype.getEleLeft = function () {
  return getReLeft(this.container);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/ArticleList/articleList.vue
//
//
//
//
//
//





/* harmony default export */ var articleList = ({
  name: 'articleList',
  components: {
    ArticleItem: ArticleItem
  },
  updated: function updated() {
    new utils_lazyImage(this.$refs.articleList, {
      miniSrc: function miniSrc(src) {
        return src;
      }
    }).start();
  },

  computed: {
    blogs: function blogs() {
      return this.$store.state.blog.value;
    }
  },
  mounted: function mounted() {
    new utils_lazyImage(this.$refs.articleList, {
      miniSrc: function miniSrc(src) {
        return src;
      }
    }).start();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58f8e2aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/ArticleList/articleList.vue
var articleList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"articleList",staticClass:"article-list-wrapper"},[_vm._l((_vm.blogs),function(blog,index){return _c('ArticleItem',{key:blog.id,attrs:{"blog":blog,"index":index}})}),_vm._v(" "),(!_vm.blogs.length)?_c('div',{staticClass:"loader"}):_vm._e()],2)}
var articleList_staticRenderFns = []
var articleList_esExports = { render: articleList_render, staticRenderFns: articleList_staticRenderFns }
/* harmony default export */ var ArticleList_articleList = (articleList_esExports);
// CONCATENATED MODULE: ./src/layouts/ArticleList/articleList.vue
function articleList_injectStyle (ssrContext) {
  __webpack_require__("ZyRR")
}
var articleList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var articleList___vue_template_functional__ = false
/* styles */
var articleList___vue_styles__ = articleList_injectStyle
/* scopeId */
var articleList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var articleList___vue_module_identifier__ = null
var articleList_Component = articleList_normalizeComponent(
  articleList,
  ArticleList_articleList,
  articleList___vue_template_functional__,
  articleList___vue_styles__,
  articleList___vue_scopeId__,
  articleList___vue_module_identifier__
)

/* harmony default export */ var layouts_ArticleList_articleList = (articleList_Component.exports);

// CONCATENATED MODULE: ./src/layouts/ArticleList/index.js
/**
 * Created by lenovo on 2017/11/23.
 */


/* harmony default export */ var ArticleList = (layouts_ArticleList_articleList);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Home.vue
//
//
//
//
//
//



/* harmony default export */ var Home = ({
  name: 'Home',
  components: {
    ArticleList: ArticleList
  },
  data: function data() {
    return {
      loading: false
    };
  },
  beforeMount: function beforeMount() {
    this.$store.dispatch('getBlogs');
  },

  methods: {
    handleLoading: function handleLoading(e) {
      this.loading = !this.loading;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc1362f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('ArticleList')],1)}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var pages_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/pages/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("liog")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = "data-v-fc1362f2"
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  pages_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_pages_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Tags/tags.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var tags = ({
  components: {
    Tag: Tag
  },
  computed: {
    labels: function labels() {
      return this.$store.state.blog.labels;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e15769f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Tags/tags.vue
var tags_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("所有标签：")]),_vm._v(" "),_vm._l((_vm.labels),function(label){return (_vm.labels.length)?_c('Tag',{key:label.id,attrs:{"color":label.color,"src":'/tags/' + label.name}},[_vm._v("\n    "+_vm._s(label.name)+"\n  ")]):_c('div',{staticClass:"loader"})}),_vm._v(" "),_c('router-view')],2)}
var tags_staticRenderFns = []
var tags_esExports = { render: tags_render, staticRenderFns: tags_staticRenderFns }
/* harmony default export */ var Tags_tags = (tags_esExports);
// CONCATENATED MODULE: ./src/pages/Tags/tags.vue
var tags_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tags___vue_template_functional__ = false
/* styles */
var tags___vue_styles__ = null
/* scopeId */
var tags___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tags___vue_module_identifier__ = null
var tags_Component = tags_normalizeComponent(
  tags,
  Tags_tags,
  tags___vue_template_functional__,
  tags___vue_styles__,
  tags___vue_scopeId__,
  tags___vue_module_identifier__
)

/* harmony default export */ var pages_Tags_tags = (tags_Component.exports);

// CONCATENATED MODULE: ./src/pages/Tags/index.js
/**
 * Created by wython on 2017/11/30.
 */



/* harmony default export */ var Tags = (pages_Tags_tags);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cadf1c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About/about.vue
var about_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  about\n")])}
var about_staticRenderFns = []
var about_esExports = { render: about_render, staticRenderFns: about_staticRenderFns }
/* harmony default export */ var about = (about_esExports);
// CONCATENATED MODULE: ./src/pages/About/about.vue
var about_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var about___vue_template_functional__ = false
/* styles */
var about___vue_styles__ = null
/* scopeId */
var about___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var about___vue_module_identifier__ = null
var about_Component = about_normalizeComponent(
  __vue_script__,
  about,
  about___vue_template_functional__,
  about___vue_styles__,
  about___vue_scopeId__,
  about___vue_module_identifier__
)

/* harmony default export */ var About_about = (about_Component.exports);

// CONCATENATED MODULE: ./src/pages/About/index.js
/**
 * Created by wython on 2017/11/30.
 */



/* harmony default export */ var About = (About_about);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85aa1f90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Archive/archive.vue
var archive_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("archive")])}
var archive_staticRenderFns = []
var archive_esExports = { render: archive_render, staticRenderFns: archive_staticRenderFns }
/* harmony default export */ var archive = (archive_esExports);
// CONCATENATED MODULE: ./src/pages/Archive/archive.vue
var archive_normalizeComponent = __webpack_require__("VU/8")
/* script */
var archive___vue_script__ = null
/* template */

/* template functional */
var archive___vue_template_functional__ = false
/* styles */
var archive___vue_styles__ = null
/* scopeId */
var archive___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var archive___vue_module_identifier__ = null
var archive_Component = archive_normalizeComponent(
  archive___vue_script__,
  archive,
  archive___vue_template_functional__,
  archive___vue_styles__,
  archive___vue_scopeId__,
  archive___vue_module_identifier__
)

/* harmony default export */ var Archive_archive = (archive_Component.exports);

// CONCATENATED MODULE: ./src/pages/Archive/index.js
/**
 * Created by wython on 2017/11/30.
 */



/* harmony default export */ var Archive = (Archive_archive);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ee5ab46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Page404.vue
var Page404_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  404\n")])}
var Page404_staticRenderFns = []
var Page404_esExports = { render: Page404_render, staticRenderFns: Page404_staticRenderFns }
/* harmony default export */ var Page404 = (Page404_esExports);
// CONCATENATED MODULE: ./src/pages/Page404.vue
var Page404_normalizeComponent = __webpack_require__("VU/8")
/* script */
var Page404___vue_script__ = null
/* template */

/* template functional */
var Page404___vue_template_functional__ = false
/* styles */
var Page404___vue_styles__ = null
/* scopeId */
var Page404___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Page404___vue_module_identifier__ = null
var Page404_Component = Page404_normalizeComponent(
  Page404___vue_script__,
  Page404,
  Page404___vue_template_functional__,
  Page404___vue_styles__,
  Page404___vue_scopeId__,
  Page404___vue_module_identifier__
)

/* harmony default export */ var pages_Page404 = (Page404_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Article/article.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var article = ({
  data: function data() {
    return {
      marked: marked_default.a,
      moment: moment_default.a
    };
  },
  beforeMount: function beforeMount() {
    var number = this.$route.params.id;
    this.$store.dispatch('setCurrentBlog', number);
  },

  computed: {
    blog: function blog() {
      return this.$store.state.blog.currentBlog || { title: '', body: '' };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2fc259c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Article/article.vue
var article_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.blog.title)?_c('div',{staticClass:"loader"}):_c('div',{staticClass:"article-page"},[_c('h2',[_vm._v(_vm._s(_vm.blog.title))]),_vm._v(" "),_c('p',{staticClass:"article-mess"},[_c('span',{staticClass:"date-line"},[_vm._v(_vm._s(_vm.moment.duration(Date.now() - Date.parse(new Date(_vm.blog.created_at))).humanize(true))+" | "),_c('span',{staticClass:"icon eye"}),_vm._v(" 评论数 "+_vm._s(_vm.blog.comments))])]),_vm._v(" "),_c('div',{attrs:{"id":"marked-view"},domProps:{"innerHTML":_vm._s(_vm.marked(_vm.blog.body))}})])}
var article_staticRenderFns = []
var article_esExports = { render: article_render, staticRenderFns: article_staticRenderFns }
/* harmony default export */ var Article_article = (article_esExports);
// CONCATENATED MODULE: ./src/pages/Article/article.vue
function article_injectStyle (ssrContext) {
  __webpack_require__("v1Y3")
}
var article_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var article___vue_template_functional__ = false
/* styles */
var article___vue_styles__ = article_injectStyle
/* scopeId */
var article___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var article___vue_module_identifier__ = null
var article_Component = article_normalizeComponent(
  article,
  Article_article,
  article___vue_template_functional__,
  article___vue_styles__,
  article___vue_scopeId__,
  article___vue_module_identifier__
)

/* harmony default export */ var pages_Article_article = (article_Component.exports);

// CONCATENATED MODULE: ./src/pages/Article/index.js
/**
 * Created by wython on 2017/11/30.
 */


/* harmony default export */ var Article = (pages_Article_article);
// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/store/api.js




var getRequest = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(url, params) {
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios_default.a.get(url, {
              params: extends_default()({}, params, {
                state: 'open',
                client_id: '62590fb1780535d59439'
              })
            });

          case 2:
            return _context.abrupt('return', _context.sent);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();



var origin = 'https://api.github.com/repos/wython/wython.github.io';

var api_url = {
  issues: origin + '/issues',
  labels: origin + '/labels'
};

var BlogService = {
  getBlogs: function getBlogs(label, page) {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getRequest(api_url.issues, {
                label: label,
                page: page
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  getBlog: function getBlog(id) {
    var _this2 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getRequest(api_url.issues + '/' + id, {
                state: 'open'
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }))();
  },

  /**
   * 获取labels标签
   */
  getLabels: function getLabels() {
    var _this3 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return getRequest('' + api_url.labels, {});

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this3);
    }))();
  }
};

/* harmony default export */ var api = ({ BlogService: BlogService });
// CONCATENATED MODULE: ./src/store/blog.js





/* harmony default export */ var blog = ({
  state: {
    value: [],
    currentPage: 1,
    currentBlog: null,
    labels: []
  },
  actions: {
    getBlogs: function getBlogs(_ref, payload) {
      var _this = this;

      var commit = _ref.commit,
          state = _ref.state;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var res;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return BlogService.getBlogs('blog', payload);

              case 2:
                res = _context.sent;


                commit('init', {
                  value: res.data
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setCurrentBlog: function setCurrentBlog(_ref2, payload) {
      var _this2 = this;

      var commit = _ref2.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var res;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return BlogService.getBlog(payload);

              case 2:
                res = _context2.sent;

                commit('setCurrentBlog', res.data);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getLabels: function getLabels(_ref3) {
      var _this3 = this;

      var commit = _ref3.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var res;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return BlogService.getLabels();

              case 2:
                res = _context3.sent;

                commit('getLabels', res.data);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    clearBlog: function clearBlog(_ref4) {
      var _this4 = this;

      var commit = _ref4.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commit('clearBlogs');

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  },
  mutations: {
    init: function init(state, payload) {
      state.value = payload.value;
      state.currentPage = payload.currentPage;
    },
    setCurrentBlog: function setCurrentBlog(state, payload) {
      state.currentBlog = payload;
    },
    getLabels: function getLabels(state, payload) {
      state.labels = payload;
    },
    clearBlogs: function clearBlogs(state) {
      state.value = [];
    }
  }
});
// CONCATENATED MODULE: ./src/store/index.js
/**
 * Created by wython on 2017/11/17.
 */




vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {},

  modules: {
    blog: blog
  },
  strict: debug
}));
// CONCATENATED MODULE: ./src/router/index.js



/*-------  page ----------*/








vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'hash',
  routes: [{
    path: '/',
    name: 'Home',
    component: src_pages_Home
  },
  // {
  //   path: '/archive',
  //   name: 'Archive',
  //   component: Archive
  // },
  {
    path: '/tags',
    name: 'Tags',
    component: Tags,
    children: [{
      path: ':label',
      name: 'Label',
      component: ArticleList,
      beforeEnter: function beforeEnter(to, from, next) {
        // ...
        console.log(to);
        store.dispatch('clearBlog');
        store.dispatch('getBlogs', {
          label: to.params.label
        });
        next();
      },
      beforeRouteLeave: function beforeRouteLeave() {
        store.dispatch('clearBlogs');
        next();
      }
    }]
  }, {
    path: '/about',
    name: 'About',
    component: About
  }, {
    path: '/article/:id',
    name: 'article',
    component: Article
  }, {
    path: '*',
    component: pages_Page404
  }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// vuex require a Promise polyfill in IE








vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "U2pc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WqB3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZyRR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "il8T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ioxL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "je8i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jikQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k7QP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "liog":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v1Y3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.06b4461840c628f15ca2.js